import Axios from "axios"
import React from "react"
import { sortCaret } from "../../../_metronic/_helpers";
/* const url_locations_dev = "http://localhost:5000/gt-out/us-central1/api/v1/locations"; */
const url_locations = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/locations";

export const columns = [
  {
    dataField: "no",
    text: "No",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "image",
    text: "Image",
    sort: true,
    sortCaret: sortCaret,

    rowStyle: {
      height: "100px"
    },
    formatter: (cell, row, i, addons = {}) => {
      return (

        <img
          alt="product"
          className="image-fluid rounded cursor-pointer"
          height="90px"
          onClick={() => typeof addons.controller === "function" && addons.controller(row)}
          width="90px"
          src={row.image || "https://firebasestorage.googleapis.com/v0/b/gto-mkt-dev.appspot.com/o/location.jpeg?alt=media&token=140223c7-ceda-4618-ba74-5750a3be2dd7"}
        />

      )
    }
  },
  {
    dataField: "name",
    text: "Location name",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "address",
    text: "Address",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "state",
    text: "State",
    sort: true,
    sortCaret: sortCaret,
  },

  {
    dataField: "city",
    text: "City",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "zipcode",
    text: "ZIPCODE",
    sort: true,
    sortCaret: sortCaret,
  }
];

export function getClients(setClients) {
  Axios.get(`${url_locations}/find`)
    .then((res) => {
      const locations = res.data.payload;
      console.log(locations)
      setClients(locations);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getClient(uid) {
  return Axios.get(`${url_locations}/find/${uid}`)
}
export function updateClient(location) {
  if (location.uid) {

    return Axios.put(`${url_locations}/update/${location.uid}`, location);
  } else {
    return Axios.post(`${url_locations}/create`, location);

  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_locations}/delete/${uid}`)
}